import React, { useState } from "react";
import Cookies from "universal-cookie";

const cookie = new Cookies();

const EnviarInformeOM = () => {
  const [correo, setCorreo] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [loading, setLoading] = useState(false);

  const handleEnviar = async () => {
    if (!correo) {
      setMensaje("⚠️ Debes ingresar un correo");
      return;
    }

    try {
      setLoading(true);
      setMensaje("");

      const tipoUsuario = cookie.get("tipo_Usuario");
      const institucionId = cookie.get("institucionid");

      // 🔥 Lógica de condición
      const id = tipoUsuario == 1 ? 0 : institucionId;

      const url = `https://suadesarrollo.azurewebsites.net/api/EnviarInformeOmGestion/${id}/${correo}`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Error en la solicitud");
      }

      const data = await response.json();

      // ✅ Mostrar mensaje del backend
      setMensaje(data.mensaje);
    } catch (error) {
      console.error(error);
      setMensaje("❌ Ocurrió un error al enviar el informe");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <label style={styles.label}>
        Si desea generar un informe diligencie el siguiente campo y de click en
        enviar
      </label>

      <input
        type="email"
        placeholder="ejemplo@correo.com"
        value={correo}
        onChange={(e) => setCorreo(e.target.value)}
        style={styles.input}
      />

      <button onClick={handleEnviar} style={styles.button} disabled={loading}>
        {loading ? "Enviando..." : "Enviar Informe"}
      </button>

      {mensaje && <p style={styles.mensaje}>{mensaje}</p>}
    </div>
  );
};

export default EnviarInformeOM;

const styles = {
  container: {
    maxWidth: "400px",
    margin: "40px auto",
    padding: "25px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    textAlign: "center",
    background: "#fff",
  },
  title: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "bold",
  },
  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    marginBottom: "15px",
    fontSize: "14px",
  },
  button: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "none",
    background: "linear-gradient(135deg, #007bff, #00c6ff)",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "0.3s",
  },
  mensaje: {
    marginTop: "15px",
    fontSize: "14px",
    color: "#333",
  },
};
